import { Check } from "lucide-react";
import { useT } from "@/i18n";

export const STEP_KEYS = ["package", "mode", "details", "summary", "payment"];

export function OrderStepper({ current }) {
  const { t } = useT();
  const W = t.order.wizard;
  const total = STEP_KEYS.length;
  return (
    <div data-testid="order-stepper" className="px-6 sm:px-8 pt-5">
      <p data-testid="order-step-counter" className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">
        {W.step_of.replace("{n}", String(Math.min(current + 1, total))).replace("{total}", String(total))}
      </p>
      <ol className="flex items-center gap-1.5 sm:gap-2">
        {STEP_KEYS.map((key, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <li key={key} data-testid={`order-step-${key}`} data-state={done ? "done" : active ? "active" : "todo"} className="flex-1 min-w-0">
              <div className={`h-1.5 rounded-full transition-colors duration-300 ${done ? "bg-brand-teal" : active ? "bg-brand-teal/60" : "bg-slate-200 dark:bg-slate-700"}`} />
              <div className={`mt-2 flex items-center gap-1 text-[11px] leading-tight truncate ${active ? "font-semibold text-foreground" : done ? "text-brand-teal" : "text-muted-foreground"}`}>
                {done ? <Check size={11} className="shrink-0" /> : <span className="font-mono shrink-0">{i + 1}.</span>}
                <span className="truncate">{W.steps[key]}</span>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
